import { jsx as e, jsxs as S, Fragment as R } from "react/jsx-runtime";
import { debug as O, error as w } from "@imprivata-cloud/common";
import { JsonToHtml as B, Modal as _, Button as b, Select as D } from "@imprivata-cloud/components";
import * as d from "react";
import { useRef as x, useEffect as M, useState as y, useCallback as f } from "react";
import { useTranslation as T } from "react-i18next";
import { k as z, e as I, g as j, C as g } from "./index-B_Mi3W2t.js";
import { C as k } from "./api-DwyZ-w1t.js";
import { LoadingOutlined as A } from "@ant-design/icons";
import { Flex as H, Spin as P } from "antd";
const G = (n) => /* @__PURE__ */ d.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n }, /* @__PURE__ */ d.createElement("g", { clipPath: "url(#clip0_6513_1362)" }, /* @__PURE__ */ d.createElement("path", { d: "M16.591 13.409C15.7123 12.5303 14.2877 12.5303 13.409 13.409C12.5303 14.2877 12.5303 15.7123 13.409 16.591L20.818 24L13.409 31.409C12.5303 32.2877 12.5303 33.7123 13.409 34.591C14.2877 35.4697 15.7123 35.4697 16.591 34.591L24 27.182L31.409 34.591C32.2877 35.4697 33.7123 35.4697 34.591 34.591C35.4697 33.7123 35.4697 32.2877 34.591 31.409L27.182 24L34.591 16.591C35.4697 15.7123 35.4697 14.2877 34.591 13.409C33.7123 12.5303 32.2877 12.5303 31.409 13.409L24 20.818L16.591 13.409Z", fill: "#D7324A" }), /* @__PURE__ */ d.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24Z", fill: "#D7324A" })), /* @__PURE__ */ d.createElement("defs", null, /* @__PURE__ */ d.createElement("clipPath", { id: "clip0_6513_1362" }, /* @__PURE__ */ d.createElement("rect", { width: 48, height: 48, fill: "white" })))), te = "BIOCONSENT-feb_2024.html", F = ({ onScroll: n, consentDocument: t, noScrollBar: r }) => {
  const c = x(null);
  return M(() => {
    t && (c != null && c.current) && c.current.scrollHeight <= c.current.clientHeight && r();
  }, [r, t]), /* @__PURE__ */ e("div", { className: "biometric-consent", "data-testid": "biometric-consent", children: /* @__PURE__ */ e("div", { ref: c, className: "consent-text", onScroll: n, children: t ? /* @__PURE__ */ e(B, { json: t }) : /* @__PURE__ */ e(H, { justify: "center", align: "center", children: /* @__PURE__ */ e(P, { indicator: /* @__PURE__ */ e(A, { spin: !0 }), size: "small" }) }) }) });
}, Z = ({
  onSubmit: n,
  onDecline: t,
  onGoBack: r,
  pickedState: c,
  consentDocument: a,
  modalRoot: p
}) => {
  const { t: o } = T(), [i, u] = y(!1), [h, m] = y(!1), E = f((N) => {
    const C = N.target;
    C.scrollHeight - C.scrollTop <= C.clientHeight + 1 && u(!0);
  }, []);
  return /* @__PURE__ */ S("div", { children: [
    /* @__PURE__ */ e("h2", { children: o("consent.screen-2-title", { state: c }) }),
    /* @__PURE__ */ e(
      F,
      {
        onScroll: E,
        consentDocument: a,
        noScrollBar: () => {
          u(!0);
        }
      }
    ),
    /* @__PURE__ */ S(
      _,
      {
        centered: !0,
        closable: !1,
        cancelText: o("consent.decline-modal.go-back-and-grant"),
        cancelButtonProps: {
          type: "primary",
          style: { backgroundColor: "#426da9" },
          size: "small",
          "data-testid": "go-back-btn"
        },
        destroyOnClose: !0,
        forceRender: !0,
        getContainer: p ?? void 0,
        open: h,
        okText: o("consent.decline"),
        onOk: t,
        onCancel: r,
        okButtonProps: { type: "link", size: "small" },
        width: 300,
        children: [
          /* @__PURE__ */ e(G, {}),
          /* @__PURE__ */ e("h4", { className: "ant-modal-title", style: { fontSize: "20px" }, children: o("consent.decline-modal.title") }),
          /* @__PURE__ */ e("p", { children: o("consent.decline-modal.text") })
        ]
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        label: o("actions.agree"),
        type: "primary",
        disabled: !i,
        "data-testid": "consent-agree-btn",
        onClick: n,
        block: !0
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        label: o("consent.decline"),
        type: "text",
        size: "small",
        "data-testid": "consent-decline-btn",
        onClick: () => m(!0),
        block: !0
      }
    )
  ] });
}, U = (n, t) => !n || t === void 0 ? !0 : t.length === 0 ? !1 : t.includes(n), v = ({
  children: n
}) => /* @__PURE__ */ e("div", { className: "consent-container w-100 flex flex-column", children: n }), ne = ({
  modalRoot: n,
  consent: t,
  onCancel: r,
  handleSubmitConsent: c,
  onError: a
}) => {
  var C;
  const p = x(null), o = x(null), [i, u] = y(void 0), h = f(
    async (l) => {
      const s = l.replace("html", "json");
      try {
        return z(s);
      } catch (L) {
        a(L);
      }
    },
    [a]
  ), m = f(
    (l, s) => {
      p.current = l, c(l, s);
    },
    [c]
  ), E = f(
    (l) => {
      if (!U(l, t == null ? void 0 : t.consentStates)) {
        m(k.EMPTY, l);
        return;
      }
      if (o.current) {
        u({ residenceState: l, document: o.current });
        return;
      }
      h(t.documentUrl).then((s) => {
        if (O("ConsentSteps: stepChange", { granted: p, residenceState: l }), !s) {
          a(I({ code: j.INTERNAL_ERROR }));
          return;
        }
        o.current = s, u({ residenceState: l, document: s });
      }).catch((s) => {
        w("ConsentSteps: failed", { error: s }), a(s);
      });
    },
    [t, m, h, a]
  );
  return p.current !== null ? /* @__PURE__ */ e(R, {}) : !((i == null ? void 0 : i.residenceState) || t.residenceState) || !i ? /* @__PURE__ */ e(v, { children: /* @__PURE__ */ e(q, { onSelect: E, onCancel: r }) }) : /* @__PURE__ */ e(v, { children: /* @__PURE__ */ e(
    Z,
    {
      consentDocument: i.document,
      pickedState: ((C = g.find((l) => l.value === i.residenceState)) == null ? void 0 : C.titleLabel) ?? "",
      onSubmit: () => m(k.GRANTED, i.residenceState),
      onDecline: () => m(k.DECLINED, i.residenceState),
      onGoBack: () => u(void 0),
      modalRoot: n
    }
  ) });
}, q = ({ onSelect: n, onCancel: t }) => {
  const { t: r } = T(), [c, a] = y(g[0].value);
  return /* @__PURE__ */ S(R, { children: [
    /* @__PURE__ */ e("h2", { children: r("consent.step-1.header") }),
    /* @__PURE__ */ S("p", { className: "consent-state-selection-paragraph", children: [
      r("consent.step-1.text"),
      " ",
      /* @__PURE__ */ e("br", {}),
      r("consent.step-1.text-2")
    ] }),
    /* @__PURE__ */ e(
      D,
      {
        label: r("consent.state-picker-label"),
        "data-testid": "state-of-residence-select",
        autoFocus: !0,
        defaultValue: g[0],
        options: g,
        onChange: a,
        style: { width: "100%" }
      }
    ),
    /* @__PURE__ */ e(
      b,
      {
        label: r("actions.continue"),
        type: "primary",
        onClick: () => n(c),
        "data-testid": "state-select-continue-button"
      }
    ),
    /* @__PURE__ */ e(b, { label: r("consent.resident-decline"), type: "text", size: "small", onClick: t })
  ] });
};
export {
  te as B,
  ne as C
};
//# sourceMappingURL=ConsentSteps-Boru81Lg.js.map
